import Vue from 'vue';

Vue.filter('shortTime', function (value) {
    return value ? value.substring(0, 5) : '';
});